import { makeStyles } from "@material-ui/core/styles";
import FeedActivity from "./FeedActivity.jsx";
import NotificationCard from "./NotificationCard.jsx";
import TitleBar from "../TitleBar.jsx";
import { useState } from "react";
import BadgePopup from "../Badges/BadgePopup.jsx";
import { getBadgeDetails } from "../Badges/BadgeData.jsx";
import { getGermanDate } from "../../lib/utilities.js";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2, 0),
  },
}));

function Feed() {
  const classes = useStyles();
  const [badgeContent, setBadgeContent] = useState({
    open: false,
    title: "",
    text: "",
    id: 1,
    amount: "",
    unit: "",
  });

  return (
    <>
      <TitleBar title="Feed" followIcon />
      <NotificationCard />
      <div className={classes.root}>
        {badgeContent.open && (
          <BadgePopup
            open={badgeContent.open}
            badgeDetails={{
              color: getBadgeDetails(badgeContent.id).color,
              title: badgeContent.title,
              longDescription: badgeContent.text,
              icon: getBadgeDetails(badgeContent.id).icon,
            }}
            amount={badgeContent.amount}
            unit={badgeContent.unit}
            achieved={getGermanDate()}
            close={() =>
              setBadgeContent({ open: false, text: "", title: "", amount: "", unit: "", id: 1 })
            }
          />
        )}
        <FeedActivity setBadgeContent={setBadgeContent} />
      </div>
    </>
  );
}

export default Feed;
